import React from 'react';

export default {
  width: 25,
  height: 18,
  fill: 'none',
  content: <path opacity="0.1" d="M1 8.5L8.5 16L23.5 1" stroke="black" strokeWidth="2" />
};
